<template>
  <div class="flex information" @click="toEdit" >
    <!-- 头像 -->
    <div>
      <img class="userPhoto" :src="userInfo.headUrl ?
      userInfo.headUrl :
      '../../../static/img/default.png'"/>
    </div>
    <!-- 简介 -->
    <div class="flex1 introduction center">
        <div class="userName flex">
            <div class="text-align-left user-info-nick">{{ userInfo.nick }}</div>
            <!--<div @click.stop="reflash" class="small_font reflash">
                <svg class="smallIcon" aria-hidden="true" slot="icon">
                    <use xlink:href="#icon-reflash"></use>
                </svg>
                <span>{{ menuTypes.reflash }}数据</span>
            </div>-->

            <!-- 详情 -->
            <div class="flex1 text-align-right user-info-icon">
                <router-link to="/user/detail">
                    <div style="padding-right: 0.33rem">
                        <svg class="smallIcon" aria-hidden="true" slot="icon">
                            <use xlink:href="#icon-right"></use>
                        </svg>
                    </div>
                </router-link>
            </div>
        </div>
        <div class="small_font text-align-left user-info-sign">
          <div class="member-container" style="display: flex;align-items: center;">
            <!--<img src="../../../static/img/xz.png" style="width: 0.15rem;"/>-->
            <member-level :user-info="userInfo">
            </member-level>
            <span class="item no" style="margin-right: 0;">编号:{{ userInfo.memberNo }}</span>
          </div>
          <span style="cursor: pointer; display: inline-block;padding-left: 0.25rem;"
                v-if="showTime" @click.stop="showTimeItem">{{ formatTime2(userInfo.createDate) }} 注册</span>
          <span style="cursor: pointer;" v-else @click.stop="showTimeItem"> {{ dateFormat(userInfo.createDate) }} </span>
        </div>
    </div>

  </div>
</template>

<script>
import { formate } from '../../utils/utils';
import MemberLevel from './components/MemberLevel';

export default {
  props: ['userInfo', 'menuTypes'],
  name: 'Information',
  components: {
    MemberLevel,
  },
  data(){
  	return{
  		showTime: true
  	}
  },

  methods: {
      reflash() {
          this.$store.dispatch('user/init');
      },
      showTimeItem(){
      	this.showTime = !this.showTime
      },
      toEdit(){
      	this.$router.push({path:'/user/detail'});
      },
      dateFormat: function(timestamp) {
          return formate(timestamp);
      },
      formatTime2(dateTimeStamp){
      	var minute = 1000 * 60;      //把分，时，天，周，半个月，一个月用毫秒表示
	    var hour = minute * 60;
	    var day = hour * 24;
	    var week = day * 7;
	    var halfamonth = day * 15;
	    var month = day * 30;
	    var now = new Date().getTime();   //获取当前时间毫秒
	//  console.log(now)
	    var diffValue = now - dateTimeStamp;//时间差

	    if(diffValue < 0){
	        return;
	    }
	    var minC = diffValue/minute;  //计算时间差的分，时，天，周，月
	    var hourC = diffValue/hour;
	    var dayC = diffValue/day;
	    var weekC = diffValue/week;
	    var monthC = diffValue/month;
	    let result = "";
	    if(monthC >= 1 && monthC <= 6){
	        result = " " + parseInt(monthC) + "个月前"
	    }else if(weekC >= 1 && weekC <= 4){
	        result = " " + parseInt(weekC) + "周前"
	    }else if(dayC >= 1 && dayC <= 7){
	        result = " " + parseInt(dayC) + "天前"
	    }else if(hourC >= 1 && hourC <= 24){
	        result = " " + parseInt(hourC) + "小时前"
	    }else if(minC >= 1 && minC <= 60){
	        result =" " + parseInt(minC) + "分钟前"
	    }else if(diffValue >= 0 && diffValue <= minute){
	        result = "刚刚"
	    }else {
	        var datetime = new Date();
	        datetime.setTime(dateTimeStamp);
	        var Nyear = datetime.getFullYear();
	        var Nmonth = datetime.getMonth() + 1 < 10 ? "0" + (datetime.getMonth() + 1) : datetime.getMonth() + 1;
	        var Ndate = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
	        var Nhour = datetime.getHours() < 10 ? "0" + datetime.getHours() : datetime.getHours();
	        var Nminute = datetime.getMinutes() < 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
	        var Nsecond = datetime.getSeconds() < 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
	        result = Nyear + "-" + Nmonth + "-" + Ndate
	    }
	    return result;
      }
  }
}
</script>
<style lang="scss" scoped>
@import '../../style/mixin.scss';

.information {
  //padding: 0 .33rem 0 .3rem;
  padding-left: .3rem;
}

.introduction {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.member-container {
  .item {
    display: inline-block;
    margin-left: 0.1rem;
    flex: 3;
    &.no {
      flex: 5;
    }
  }
}
.user-info-nick {
  @include word-ellipsis();
  max-width: 1.1rem;
  margin-right: .1rem;
  font-size: .2rem;
  line-height: .28rem;
  opacity: 1;
}

.user-info-sign {
  line-height: .2rem;
  margin-top: .05rem;
}

.user-info-icon {
  font-size: .12rem;
}

.reflash {
  padding: 0 .06rem 0 .02rem;
  margin: 0;
  border: 1px solid currentColor;
  border-radius: .1rem;
  opacity: 1;
}

.nomal_box {
  	.userPhoto {
      display: block;
  		width:0.64rem;
  		height:0.64rem;
      margin-right: .24rem;
      border-radius:50%;
      border: 3px solid #fff;
      box-sizing: border-box;
  	}
  	.borderColor {
  		border: 1px solid #FFFFFF;
  		border-radius:0.20rem;
  		height: 0.21rem;
  		line-height: 0.19rem;
  		font-size: 0.12rem;
  		margin-top: 0.04rem;
  	}
  	.userName {
  		font-size: 0.20rem;
      align-items: center;
    }
    .smallIcon {
        width: 1em !important;
        height: 1em !important;
        vertical-align: -0.15em;
        fill: currentColor;
        overflow: hidden;
    }
    .overflow {
        max-width: 1.2rem;
        min-width: .8rem;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/userElement/Information.vue